import React from 'react';

const BenefitCard = ({ text, icon, type, color, offset }) => {
	return (
		<div className={type == 'full' ? 'benefit-card--fullWidth' : 'benefit-card benefit-card--halfWidth'}>
			<img
				style={{ position: 'relative', top: offset + 'px' }}
				className={type == 'full' ? 'benefit-card__image' : 'benefit-card__image--halfWidth'}
				src={icon}
			/>
			<span
				style={{ color: color }}
				className={type == 'full' ? 'benefit-card__text' : 'benefit-card__text benefit-card__text--halfWidth'}
			>
				{text}
			</span>
		</div>
	);
};

export default BenefitCard;
